import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Resource schema for the `tier` type. tio-api serves contribution-plan tiers
// as a JSON:API relationship/resource (api/v1/tier_resource.rb, type `tier`)
// since the plan-tiers attribute→relationship swap (tio-api #5954). Routes that
// `include` `plans.tiers` (e.g. companies/show/repayment) therefore sideload
// `tier` resources; without this schema JSONAPICache.putOne throws
// "Missing Resource Type: 'tier'", which escalates to the ModelSchemaProvider
// recursion (RangeError) on deployed builds.
//
// NOTE: `plan.tiers` is still modeled as an ATTRIBUTE on plan (read as an array
// by summary/benefit-detail-drawer/create-plan-form and written by
// create-plan-form), so this resource is intentionally additive — `plan` is
// inverse:null here and we do NOT add a `tiers` relationship to plan. Aligning
// plan.tiers to a real relationship is the broader #5954 work.
const TierSchema = withDefaults({
  type: 'tier',
  fields: [
    { kind: 'attribute', name: 'fromCycle' },
    { kind: 'attribute', name: 'amount' },
    { kind: 'attribute', name: 'per' },
    { kind: 'attribute', name: 'percentage' },
    { kind: 'attribute', name: 'maximum' },
    { kind: 'attribute', name: 'overrideAmount' },
    { kind: 'attribute', name: 'overridePercentage' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    {
      kind: 'belongsTo',
      name: 'plan',
      type: 'plan',
      options: {
        async: false,
        inverse: null,
      },
    },
  ],
});

export default TierSchema;
